import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { secretService } from '@/services/secret-service';
import type { Secret } from '@/types/core/secret';
import { isEmptyUUID, type UUID } from '@/utils/uuid';

import { secretQueryKeys } from './query-keys';

/**
 * Find a specific secret by ID.
 * Returns a react-query query.
 */
export function useFindSecret(
  tenantId?: UUID,
  secretId?: UUID
): UseQueryResult<Secret | null, Error> {
  return useQuery<Secret | null, Error>({
    queryKey: secretQueryKeys.detail(tenantId, secretId),
    queryFn: async () => {
      if (isEmptyUUID(tenantId) || isEmptyUUID(secretId)) return null;
      return secretService.findSecret(tenantId!, secretId!);
    },
    enabled: !isEmptyUUID(tenantId) && !isEmptyUUID(secretId),
  });
}
